// extracted by mini-css-extract-plugin
export default {"root":"PrivacyTip_root__DXSEx","icon":"PrivacyTip_icon__5-YKr"};